import { WAREHOUSE_GROUP } from '../constants/officeTypeGroups';
import { EConditionType } from '../types/conditionType';
import { EConditionTypeLegacy, EOfficeType } from '../../api-models/common/json_query';

export function getLegacyConditionTypeForOffice(conditionType: EConditionType[]): EConditionTypeLegacy[] | undefined {
  const legacy = conditionType.reduce<EConditionTypeLegacy[]>((acc, type) => {
    if (type === EConditionType.WithDecoration || type === EConditionType.OfficeDecoration) {
      acc.push(EConditionTypeLegacy.OfficeDecoration);
    }
    if (type === EConditionType.RegularRepair || type === EConditionType.FullDecorationNeeded) {
      acc.push(EConditionTypeLegacy.FullDecorationNeeded);
    }
    if (type === EConditionType.MajorRepairNeeded) {
      acc.push(EConditionTypeLegacy.MajorRepairNeeded);
    }
    if (type === EConditionType.CosmeticRepairNeeded) {
      acc.push(EConditionTypeLegacy.CosmeticRepairNeeded);
    }

    return acc;
  }, []);

  return legacy.length ? legacy : undefined;
}

export function getLegacyConditionTypeForTradeAreaGroup(
  conditionType: EConditionType[],
  officeType: EOfficeType[],
): EConditionTypeLegacy[] | undefined {
  const legacy = conditionType.reduce<EConditionTypeLegacy[]>((acc, type) => {
    if (type === EConditionType.WithDecoration || type === EConditionType.DesignerRepair) {
      acc.push(EConditionTypeLegacy.DesignerRepair);
    }
    if (type === EConditionType.RegularRepair) {
      acc.push(EConditionTypeLegacy.RegularRepair);
      if (!officeType.length || officeType.some(t => t === EOfficeType.Office || WAREHOUSE_GROUP.includes(t))) {
        acc.push(EConditionTypeLegacy.FullDecorationNeeded);
      }
    }
    if (type === EConditionType.FullDecorationNeeded) {
      acc.push(EConditionTypeLegacy.FullDecorationNeeded);
    }
    if (type === EConditionType.MajorRepairNeeded) {
      acc.push(EConditionTypeLegacy.MajorRepairNeeded);
    }
    if (type === EConditionType.CosmeticRepairNeeded) {
      acc.push(EConditionTypeLegacy.CosmeticRepairNeeded);
    }

    return acc;
  }, []);

  return legacy.length ? legacy : undefined;
}

export function getLegacyConditionTypeForWarehouseGroup(
  conditionType: EConditionType[],
): EConditionTypeLegacy[] | undefined {
  const legacy = conditionType.reduce<EConditionTypeLegacy[]>((acc, type) => {
    if (type === EConditionType.RegularRepair) {
      acc.push(EConditionTypeLegacy.RegularRepair);
    }
    if (type === EConditionType.MajorRepairNeeded) {
      acc.push(EConditionTypeLegacy.MajorRepairNeeded);
    }
    if (type === EConditionType.CosmeticRepairNeeded) {
      acc.push(EConditionTypeLegacy.CosmeticRepairNeeded);
    }

    return acc;
  }, []);

  return legacy.length ? legacy : undefined;
}
